import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-action-form-buttons',
    templateUrl: './action-form-buttons.component.html',
    styleUrls: ['./action-form-buttons.component.scss'],
})
export class ActionFormButtonsComponent {
    @Output() save = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    @Input() saveBtnTitle = 'system.save';
    @Input() saveBtnDisable = false;
    @Input() cancelBtnTitle = 'system.cancel';
    @Input() cancelBtnDisable = false;

    @Input() saveAdditionalClass = 'btn-primary';
    @Input() cancelAdditionalClass = 'btn-secondary';

    onSave() {
        this.save.emit();
    }

    onCancel() {
        this.cancel.emit();
    }
}
